.footerBox {
    width: 100%;
    min-height: var(--customer-panel-bottom-control-footer-height);
    position: sticky;
    bottom: 0;
    align-items: center;
    justify-content: space-between;
    padding: 1rem;
    flex-wrap: wrap;
    gap: 1rem;
}
.actionText:disabled {
    background: #d5d6da1f;
}

:root {
    --customer-panel-bottom-control-footer-height: 60px;
}

.quickRebuttalButton {
    border: 1px solid;
    border-radius: 9999px;
    padding: 8px 16px;
}
